import React from "react";
import Productionone from "../components/Section/ProductionOne";
import Productiontwo from "../components/Section/ProductionTwo"


function Production() {
 

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
    
        <Productionone />

        <Productiontwo />
    </div>
  );
}

export default Production;
